import React from 'react';
import { cn, normalizeKey } from '@/lib/utils';
// import Link from 'next/link';
import { Badge } from '@/components/ui/badge';

interface BusinessGuideSummaryProps {
  summary: {
    showDate?: boolean;
    showAuthor?: boolean;
    showTopics?: boolean;
  }
  data?: {
    date?: string;
    author?: string;
    type?: string;
  }
}

export const BusinessGuideSummary = ({ 
    summary,
    data,
}: BusinessGuideSummaryProps) => {
  const innerSectionClass = cn(
    'rounded-xl py-6 border gap-5 flex flex-col',
  );
  const blockClass = cn(
    'flex flex-col gap-1 px-4',
  );
  const titleClass = cn(
    'paragraph-sm text-foreground font-bold',
  );
  const contentClass = cn(
    'paragraph-sm text-foreground',
  );
  const listItemClass = cn(
    'flex flex-col gap-1',
  );

  const formattedDate = new Date(data?.date ?? '').toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <div className={innerSectionClass}>
      {summary.showDate && data?.date && (
        <div className={blockClass}>
          <div className={titleClass}>
            Date
          </div>
        <div className={contentClass}>
            {formattedDate}
          </div>
        </div>
      )}
      {summary.showAuthor && data?.author && (
        <div className={blockClass}>
          <div className={titleClass}>
            Written by
          </div>
          <div className={contentClass}>
            {data?.author}
          </div>
        </div>
      )}
      {summary.showTopics && data?.type && (
        <div className={blockClass}>
          <div className={titleClass}>
            Topics
          </div>
          <div className={listItemClass}>
            <Badge key={normalizeKey(data?.type ?? '')} variant="secondary">
              {data?.type}
            </Badge>
          </div>
        </div>
      )}
    </div>
  );
}; 
